import Header from "../../Common/Header";
import Forget from "../../Components/ForgotId";

const ForgetPage = () => {
  return (
    <>
      <div className="bg-primary h-screen text-white">
        <Header />  
        <Forget/>
      </div>
    </>
  );
};

export default ForgetPage;
